import { paypalPaymentAction } from './Paypal/paypal';

export type PaymentAction<T = Record<string, unknown>> = (baseUrl: string, submissionId: string, payload?: T) => Promise<void>;

export const paymentHandler: Record<string, PaymentAction> = { Paypal: paypalPaymentAction };
